import React, { useEffect, useState } from 'react'
import { Row, Col, Checkbox } from 'rsuite'
import { requiredFiled, isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function InputCheckboxSingleForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  onChange = () => {},
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || false
  const [inputValue, setInputValue] = useState(props.value || schema?.value)

  useEffect(() => {
    setInputValue(props.value || schema?.value)
  }, [props.value, schema])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}

          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(schema.validators)}
              defaultValue={inputValue}
              render={(props) => {
                return (
                  <Checkbox
                    checked={inputValue}
                    disabled={disabled || schema.disabled}
                    onChange={(_, checked) => {
                      props.onChange(checked)
                      setInputValue(checked)
                      onChange(checked)
                    }}
                  >
                    {schema.label}
                  </Checkbox>
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
